import React, { useMemo, useState } from 'react'
import { Drawer, DatePicker, Dropdown, Menu, Tabs } from 'antd'
import { Route, Switch, useHistory, Link, useParams } from 'react-router-dom'
import Creatable from 'react-select/creatable'
import Select from 'react-select'
import pluralize from 'pluralize'

import { AiFillDelete, AiOutlineDelete, AiOutlineDown } from 'react-icons/ai'

import { useToggle, usePet, server, useListData, normalize, summarizeProcurementInvoice, summarizeProcurementInvoiceItem } from '../../modules'
import InvoiceItem from './invoiceItem'
import NewInventoryItem from '../modals/newinventoryitem'
import NewSupplier from './newSupplier'

const { TabPane } = Tabs

const NewInvoice = ({ supplier: supp, onClose, path }) => {
    const [item, setItems] = useState([])
    const [string, setString] = useState('')
    const [index, setIndex] = useState(0)
    const [supplier, setSupplier] = useState(supp ? { label: supp.name, value: supp._id, ...supp } : null)
    const [code, setCode] = useState()
    const [stores, setStores] = useState([])
    const [store, setStore] = useState()

    const history = useHistory()

    const [newItem, toggleNewItem] = useToggle()
    const [visible, toggleVisible] = useToggle(false)
    const [newSupplier, toggleNewSupplier] = useToggle(false)

    useMemo(() => setTimeout(toggleVisible, 100), [])

    const [
        { loading: supLoading, fetch: fetchSuppliers },
        { list: suppliers = [] }
    ] = useListData('suppliers', { string }, { notify: true })

    usePet('stores', { limit: 50, active: true, order: 1 }, { notify: true, callback: ({ data }) => setStores(data.stores) })

    const searchSuppliers = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetchSuppliers()
        }
    }

    const viewItem = i => {
        setIndex(i)
        setTimeout(() => history.push(`${path}/new/${i}`), 300)
    }

    const save = (val, i) => {
        let temp = [...item]
        temp[i] = {
            ...temp[i],
            ...val
        }
        setItems(temp)
    }

    const close = () => {
        toggleVisible()
        // onClose()
        setTimeout(() => history.goBack(), 300)
    }
    
    const onComplete = ({}, notif, ops) => {
        notif('Invoice has been received', ops('success'))
        onClose()
        // close()
    }

    const removeItem = i => setItems(itms => itms.filter((_, x) => x !== i))

    const [{ loading: newLoading }, receiveInvoice] = usePet('receiveInvoice', {
        code,
        commit: false,
        items: item.map(itm => ({
            name: itm.name,
            item: itm?.item?._id,
            account: itm?.account?.value,
            singles: itm?.singles,
            bulkCount: itm.bulk,
            quantity: itm.contains,
            bp: itm.bp,
            discount: itm.discount,
            vat: itm.vat,
            batch: itm.batch,
            expiry: itm.expiry
        })),
        supplier: supplier?.value,
        store: store?.value
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Receiving invoice...' } })

    const [{ loading: newNCLoading }, receiveAndCommitInvoice] = usePet('receiveInvoice', {
        code,
        commit: true,
        items: item.map(itm => ({
            name: itm.name,
            item: itm?.item?._id,
            account: itm?.account?.value,
            singles: itm?.singles,
            bulkCount: itm.bulk,
            quantity: itm.contains,
            bp: itm.bp,
            discount: itm.discount,
            vat: itm.vat,
            batch: itm.batch,
            expiry: itm.expiry
        })),
        supplier: supplier?.value,
        store: store?.value
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Receiving invoice...' } })

    const summary = summarizeProcurementInvoice(item)

    const newItm = () => {
        setItems(itms => {
            return [
                ...itms,
                {
                    name: `Item ${item.length + 1}`,
                    issuedIn: 'Units',
                    receivedIn: 'Units',
                    bulk: 1,
                    singles: true,
                    contains: 1,
                    discount: 0,
                    account: null,
                    bp: 1,
                    vat: 0
                }
            ]
        })
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center" onClick={ receiveAndCommitInvoice }>Save & Commit Invoice</button>
                    <button className="text-white mr-2 hisani-btn-green font-medium rounded-lg text-sm px-5 py-2.5 text-center" onClick={ receiveInvoice }>Save Invoice</button>
                </div>
            }
            width="60%">
            <p className="font-extrabold text-3xl mb-0">New Invoice</p>
            <div className="sm:flex justify-center items-center mb-8">
                <Creatable
                    onCreateOption={ () => history.push(`${path}/new/addSupplier`) }
                    isLoading={supLoading}
                    loadingMessage={str => `Searching for "${str?.inputValue}"`}
                    className="min-w-56 mr-4"
                    // styles={{ input: styles => ({ ...styles, minWidth: '25em' }) }}
                    onInputChange={searchSuppliers}
                    value={supplier}
                    onChange={setSupplier}
                    options={suppliers.map(supplier => ({ label: supplier.name, value: supplier._id }))}
                    placeholder="Search for Supplier" />
                <Select
                    className="min-w-56 mr-4"
                    value={store}
                    onChange={setStore}
                    options={stores.map(sto => ({ label: sto.name, value: sto._id, ...sto }))}
                    placeholder="Select Delivery Store" />
                {/* <Creatable
                    isMulti
                    onCreateOption={toggleNewItem}
                    isLoading={invLoading}
                    loadingMessage={str => `Searching for "${str?.inputValue}"`}
                    className="min-w-80"
                    // styles={{ input: styles => ({ ...styles, minWidth: '25em' }) }}
                    onInputChange={search}
                    value={item}
                    onChange={setItems}
                    options={items.map(itm => ({
                        label: itm.name,
                        value: itm._id,
                        item: itm._id,
                        bulk: 1,
                        contains: 1,
                        discount: 0,
                        bp: 1,
                        vat: 16,
                        ...itm
                    }))}
                    placeholder="Search for inventory item" /> */}
                <div className='flex'>
                    <input
                        onChange={e => setCode(e.target.value)}
                        className="appearance-none block max-w-4xl ml-4 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-inv-item"
                        type="text"
                        placeholder="Invoice Code" />

                </div>
            </div>
            {
                item?.length > 0 ?
                    <>
                        <table className="table-auto w-full">
                            {/* Table header */}
                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                <tr>
                                    <th className="p-2 pl-4 text-center">
                                        <div className="font-semibold">No.</div>
                                    </th>
                                    <th className="p-2 text-left">
                                        <div className="font-semibold">Item</div>
                                    </th>
                                    <th className="p-2 text-left">
                                        <div className="font-semibold">Quantity</div>
                                    </th>
                                    <th className="p-2 text-left">
                                        <div className="font-semibold">Unit Price</div>
                                    </th>
                                    <th className="p-2 text-left">
                                        <div className="font-semibold">Discount</div>
                                    </th>
                                    <th className="p-2 text-left">
                                        <div className="font-semibold">VAT</div>
                                    </th>
                                    <th className="p-2 text-left">
                                        <div className="font-semibold">Total</div>
                                    </th>
                                    <th className="p-2 text-left">
                                        <div className="font-semibold"></div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                {
                                    item.map((itm, key) => {
                                        const itemSummary = summarizeProcurementInvoiceItem(itm)
                                        return <tr>
                                            <td className="p-2 h-5 text-center">{key + 1}</td>
                                            <td className="p-2 h-5">
                                                <div className="">{itm.name}</div>
                                            </td>
                                            <td className="p-2 h-5">
                                                <div className="">{Number(itm.bulk * itm.contains) === Number(itm.contains) ? `${itm.contains} ${pluralize(itm.issuedIn, itm.contains)}` : `${itm.bulk} ${pluralize(itm.receivedIn, itm.bulk)}`}</div>
                                                {Number(itm.bulk * itm.contains) !== Number(itm.contains) && <p className="text-gray-500 mb-0 text-xs italic">Contains {itm.contains} {pluralize(itm.issuedIn, itm.contains)}</p>}
                                            </td>
                                            <td className="p-2 h-5">
                                                <div className="">Ksh. {itm.bp}</div>
                                            </td>
                                            <td className="p-2 h-5">
                                                <div className="">Ksh. {itm.discount}</div>
                                            </td>
                                            <td className="p-2 h-5">
                                                <div className="">{itm.vat}%</div>
                                            </td>
                                            <td className="p-2 h-5">
                                                <div className="text-left">Ksh. {normalize(itemSummary.total)}</div>
                                            </td>
                                            <td className="p-2 h-5">
                                                <button onClick={() => viewItem(key)} className="btn py-1 shadow-none bg-gray-100 hover:bg-gray-200 hover:text">View</button>
                                                <button onClick={() => removeItem(key)} className="btn ml-2 py-1 shadow-none bg-red-100 hover:bg-red-200 hover:text">
                                                    <AiOutlineDelete className='font-base' />
                                                </button>
                                            </td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                        <div className="w-full py-5 text-center">
                            <button onClick={ newItm } className="btn py-2 px-3 text-base shadow-none bg-gray-100 hover:bg-gray-200 hover:text">Add New Item</button>
                        </div>
                        <div className="flex flex-col items-end pr-3 py-3">
                            <p className="font-semibold text-lg underline mb-2">Overview</p>
                            <p className="mb-1">Before Discount: Ksh. {normalize(summary.beforeDiscount)}</p>
                            <p className="mb-1">Discount: Ksh. {normalize(summary.discount)}</p>
                            <p className="mb-1">Before VAT: Ksh. {normalize(summary.beforeTax)}</p>
                            <p className="mb-1">VAT: Ksh. {normalize(summary.vat)}</p>
                            <p className="mb-1">Total: Ksh. {normalize(summary.total)}</p>
                        </div>
                    </>
                    :
                    <div className="w-full h-16 text-center">
                        <button onClick={ newItm } className="btn py-2 px-3 text-base shadow-none bg-gray-100 hover:bg-gray-200 hover:text">Add New Item</button>
                    </div>
            }
            <Switch>
                <Route path={ `${path}/new/addSupplier` }>
                    <NewSupplier
                        string={string}
                        onPerform={x => setSupplier({ label: x.name, value: x._id })}  />
                </Route>
                <Route path={ `${path}/new/:index` }>
                    <InvoiceItem onSave={save} record={item[index]} />
                </Route>
            </Switch>
        </Drawer>
    )
}

export default NewInvoice
